import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ProjectService } from 'src/app/modules/project/services/project.service';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
  @Input() currentPage: number = 1;
  @Input() limit: number = 10;
  @Input() totalItems: number = 0;
  @Output() pageChanged: EventEmitter<number> = new EventEmitter();
  @Output() advertisingList: EventEmitter<any> = new EventEmitter();
  @Output() startingIndex: EventEmitter<number> = new EventEmitter();
  @Input() totalPages: number = 0;
  @Input() totalDocs: number = 0;
  @Input() apiUrl: string = '';
  @Input() firstIndex: number = 0;
  values = '';
  @Input() search: string = '';
  @Input() days: number = 1;
  /**
   * constructor
   */
  constructor(private projectServices: ProjectService) { }

  /**
   * ng on changes
   * @param{SimpleChanges}changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.search) {
      if (changes.search.currentValue != changes.search.previousValue || changes.filter.currentValue != changes.filter.previousValue) {
      }
    }
  }

  /**
 * on init
 */
  ngOnInit(): void {
    // this.getPaginationList()
  }


  /**
   * Gets pagination list
   */
  public getPaginationList() {
    let apiCall$;
    // const projectId = this.LocalStorageService.get('projectId');
    // this.spinner.show();
    switch (this.apiUrl) {
      case 'api/logs/project':
        apiCall$ = this.projectServices.getApiLogsDetails(this.currentPage, this.limit, this.search, this.days);
        break;
      case 'client/logs/project':
        apiCall$ = this.projectServices.getClientLogsDetails(this.currentPage, this.limit, this.search, this.days);
        break;
      case 'client/errors/project':
        apiCall$ = this.projectServices.getClintExceptions(this.currentPage, this.limit, this.search, this.days);
        break;
      case 'api/errors/project':
        apiCall$ = this.projectServices.getApiExceptions(this.currentPage, this.limit, this.search, this.days);
        break;
      case 'analytics/client/project':
        apiCall$ = this.projectServices.getAnalytics(this.currentPage, this.limit, this.search, this.days);
        break;


      default:
        console.error('Invalid API type');

        return;
    }

    apiCall$.subscribe({
      next: (res: any) => {

        this.totalItems = res.data.totalDocs;
        this.totalPages = res.data.totalPages;
        this.totalDocs = res.data.totalDocs;
        this.firstIndex = res.data.pagingCounter;
        this.startingIndex.emit(this.firstIndex);
        this.advertisingList.emit(res.data.docs);
      },
      error: (err: any) => {
        console.log(err);
      },
    });
  }


  /**
   * Changes page
   * @param{number} page
   */
  changePage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.pageChanged.emit(page);
    }
  }

  /**
   * go to previous page
   */
  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.getPaginationList();
    }
  }

  /**
   * goto next page
   */
  goToNextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.getPaginationList();
    }
  }

  /**
   *
   * @param {any}pageNumber
   */
  goToPage(pageNumber: any): void { 
    if (pageNumber && pageNumber >= 1 && pageNumber <= this.totalPages && pageNumber !== this.currentPage) {
      this.currentPage = pageNumber;
      this.getPaginationList();
    }
  }

  /**
   * Gets page numbers
   */
  get pageNumbers(): (number | string)[] {
    const totalPagesToShow = 3;
    const currentPageIndex = this.currentPage - 1;
  
    if (this.totalItems <= this.limit) {
      // If there are fewer items than the limit, just show one page
      return [1];
    } else {
      const halfPagesToShow = Math.floor(totalPagesToShow / 2);
      let startPage: number;
      let endPage: number;
  
      if (currentPageIndex <= halfPagesToShow) {
        startPage = 1;
        endPage = totalPagesToShow;
      } else if (currentPageIndex + halfPagesToShow >= this.totalPages) {
        startPage = this.totalPages - totalPagesToShow + 1;
        endPage = this.totalPages;
      } else {
        startPage = currentPageIndex - halfPagesToShow + 1;
        endPage = currentPageIndex + halfPagesToShow;
      }
  
      let pages: (number | string)[] = Array.from({ length: endPage - startPage + 1 }, (_, index) => index + startPage);
      if (startPage > 1) {
        pages = [1, ...pages];
      }
      if (endPage < this.totalPages) {
        pages = [...pages, '...', this.totalPages];
      }
  
      return pages;
    }
  }



  /**
    * @param{number}firstIndex
    * @param{number}totalItems
    * @param{number}itemsPerPage
    */
  calculateLastIndex(firstIndex: number, totalDocs: number, itemsPerPage: number): number {
    const lastIndex = firstIndex + itemsPerPage - 1;
    return Math.min(lastIndex, totalDocs);

  }

}
